import { useTranslation } from "next-i18next";
import React from "react";

function WindowsVirtualServersServices() {
  const { t } = useTranslation(["common", "windowsCloudServer", "windowsLang"]);

  return (
    <div className="relative p-5 lg:p-12 services bg-makdosSecondaryGray">
      <h2 className="pb-12 text-5xl font-semibold text-center">{t("windowsCloudServer:whyMakdos")}</h2>
      <div className="container grid grid-cols-4 gap-10 mx-auto mb-10">

        <div className="z-10 col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle1")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription1")}</p>
        </div>

        <div className="col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle2")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription2")}</p>
        </div>


        <div className="col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle6")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription6")}</p>
        </div>


        <div className="col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle7")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription7")}</p>
        </div>


      </div>

      <div className="container grid grid-cols-4 gap-10 mx-auto mb-10">
        <div className="col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle5")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription5")}</p>
        </div>

        <div className="col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle3")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription3")}</p>
        </div>

        <div className="col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle4")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription4")}</p>
        </div>

        <div className="z-10 col-span-4 col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl">
          <h3 className="mt-5 mb-4 text-lg font-semibold">{t("windowsCloudServer:boxTitle8")}</h3>
          <p className="text-sm text-cardText">{t("windowsCloudServer:boxDescription8")}</p>
        </div>
      </div>
    </div>
  );
}

export default WindowsVirtualServersServices;
